import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import SpacedLoader from '@shared/components/loading/SpacedLoader';
import MetricPageContent from '@shared/components/organization/metrics/MetricPageContent';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useTranslation } from 'react-i18next';

export default function MetricLandingPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { currentOrg, isLoading } = useCurrentOrgDetailsFetching();

    if (!currentOrg || isLoading) return <SpacedLoader />;
    return (
        <>
            <PageHeader
                title={t('common:organization.metrics.orgTitle', { value: currentOrg?.name })}
                description={t('common:organization.metrics.description')}
                items={items}
            />
            <MetricPageContent />
        </>
    );
}
